// import "whatwg-fetch";
import axios from "axios";

class AguaSearchApi {

	results;
	requestUrl;
	resultsJson = "search/results-json";
	fullResultsJson = "search/full-fabrics-results";
	resultsTemplate = "search/results";
	eePrivateFormData = ["ACT", "site_id", "csrf_token", "result_page"];

	constructor() {}

	async getFabricsFromURL(requestUrl, formData) {
		this.requestUrl = requestUrl;
		this.updateBrowserUrl(formData);

		if(formData === undefined) {
			this.resultsJson = this.fullResultsJson;
		} else {
			const conditionsArray = [
				formData.has("category:Product_Type_Group[]"),
				formData.has("category:Fabric_Suitable_For[]"),
				formData.has("category:Product_Colour_Group[]"),
				formData.has("child:fabric_collection[]"),
			]

			if (conditionsArray.indexOf(false) === -1)
			{
				this.resultsJson = this.fullResultsJson;
			}

		}

		try {
			const results = await this.requestFabrics(formData);
			return results;
		} catch(error) {
			console.error("getFabricsFromURL", error);
		}
	}

	async requestFabrics(formData) {

		try {
			this.resultsJson = this.fullResultsJson;

			formData.append("result_page", this.resultsJson);

			const response = await axios.post({
				url: this.requestUrl,
				method: "POST"
			}, formData);

			const data = await response.data;

			return data;
		} catch(error) {
			console.error("requestFabrics", error);
			console.error("requestFabrics: Stack", error.stack)  // this will work on chrome, FF. will no not work on safari
			console.error("requestFabrics: this.requestUrl", this.requestUrl);
			console.error("requestFabrics: this.resultsJson", this.resultsJson);
		}
	}

	async requestResultHtml(requestUrl, formData) {

		debugger;
		try {
			formData.append("result_page", this.resultsTemplate);

			const response = await axios.post({
				url: requestUrl,
				method: "GET"
			}, formData);

			const data = await response.data;

			return data;
		} catch(error) {
			console.error("requestResultHtml", error);
		}
	}

	updateBrowserUrl(formData) {

		if(formData === undefined) return;

		const browserUrl = `${this.requestUrl}our-fabrics?`;
		const formString = [];
		const entriesArray = {};

		for (var pair of formData.entries()) {

			const formKey = pair[0].replace("[]", "");
			const formValue = pair[1];

			if (this.eePrivateFormData.indexOf(pair[0]) === -1) {
				if (!entriesArray.hasOwnProperty(formKey)) {
					entriesArray[formKey] = [];
				}
				entriesArray[formKey].push(formValue);
			}
		}

		const finalFormKeys = Object.keys(entriesArray);

		finalFormKeys.forEach((key) => {
			formString.push(`${key}=${entriesArray[key].join('|')}`);
		});

		window.history.replaceState({}, '', `${browserUrl}${formString.join('&')}`);

		return;

	}
}

export default AguaSearchApi;
